import { PageType, Platform } from "@reconvert/reconvert-utils";
import { APP_PLATFORM } from "../config";

export enum PagePurpose {
  ANALYTICS_DECLINE_OFFERS = "ANALYTICS_DECLINE_OFFERS",
  CHECKOUT_PAGE_ACCESSIBLE = "CHECKOUT_PAGE_ACCESSIBLE",
  LEARN_MORE_ABOUT_PAGES = "LEARN_MORE_ABOUT_PAGES",
  PRE_PURCHASE_PAGES = "PRE_PURCHASE_PAGES",
  PREVIOUS_OFFER_CONDITION = "PREVIOUS_OFFER_CONDITION",
  DISABLE_DELETE_SLOT = "DISABLE_DELETE_SLOT",
  ANNOUNCEMENT_BAR_ACCESSIBLE = "ANNOUNCEMENT_BAR_ACCESSIBLE",
  VARIANT_PRODUCT_TARGETING = "VARIANT_PRODUCT_TARGETING",
}

const useIsActiveOnPage = (purpose: PagePurpose, pageType: PageType, unleashFlag?: boolean): boolean => {
  switch (purpose) {
    case PagePurpose.ANALYTICS_DECLINE_OFFERS:
      return pageType === PageType.POST_PURCHASE_PAGE1 || pageType === PageType.POST_PURCHASE_PAGE2;
    case PagePurpose.CHECKOUT_PAGE_ACCESSIBLE:
      return (
        pageType === PageType.CHECKOUT ||
        pageType === PageType.POST_PURCHASE_PAGE1 ||
        pageType === PageType.POST_PURCHASE_PAGE2 ||
        pageType === PageType.THANK_YOU_PAGE ||
        pageType === PageType.ORDER_STATUS_PAGE ||
        pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE
      );
    case PagePurpose.LEARN_MORE_ABOUT_PAGES:
      return (
        pageType === PageType.POST_PURCHASE_PAGE1 ||
        pageType === PageType.POST_PURCHASE_PAGE2 ||
        pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE
      );
    case PagePurpose.PRE_PURCHASE_PAGES:
      return (
        pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_PAGE ||
        pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE
      );
    case PagePurpose.PREVIOUS_OFFER_CONDITION:
      return (
        pageType === PageType.POST_PURCHASE_PAGE1 ||
        pageType === PageType.POST_PURCHASE_PAGE2 ||
        pageType === PageType.THANK_YOU_PAGE ||
        pageType === PageType.ORDER_STATUS_PAGE
      );
    case PagePurpose.DISABLE_DELETE_SLOT:
      return (
        pageType === PageType.POST_PURCHASE_PAGE1 ||
        pageType === PageType.POST_PURCHASE_PAGE2 ||
        pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE
      );
    // Every page that shows conditions, except the product page: that one targets the product it
    // displays as a whole. Wix is left out because it has no resource picker to narrow variants in.
    case PagePurpose.VARIANT_PRODUCT_TARGETING:
      return (
        Platform.SHOPIFY === APP_PLATFORM &&
        (pageType === PageType.CHECKOUT ||
          pageType === PageType.POST_PURCHASE_PAGE1 ||
          pageType === PageType.POST_PURCHASE_PAGE2 ||
          pageType === PageType.THANK_YOU_PAGE ||
          pageType === PageType.ORDER_STATUS_PAGE ||
          pageType === PageType.PRE_PURCHASE_CART_PAGE ||
          pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE)
      );
    case PagePurpose.ANNOUNCEMENT_BAR_ACCESSIBLE:
      if (!unleashFlag) return false;

      return (
        Platform.SHOPIFY === APP_PLATFORM &&
        (pageType === PageType.THANK_YOU_PAGE || pageType === PageType.ORDER_STATUS_PAGE)
      );

    default:
      return false;
  }
};

export default useIsActiveOnPage;
